import React, {Component, Fragment} from "react"
import styled from "styled-components"
import padding from "@irati/ui/src/global/padding"
import {VoteTypeEdit} from "@irati/recognition/enums/Moderation"
import {Poll} from "@irati/types"
import VoteComponentBase from "./Vote"

const VoteComponent = styled(VoteComponentBase)`
  margin-bottom: ${padding.tiny};
`

interface Props {
  poll: Poll
}

interface State {
  editId: string
  editType: string
}

class VotesComponent extends Component<Props, State> {
  state = {
    editId: "",
    editType: ""
  }

  enableEditing = (editId: string, editType: VoteTypeEdit) => {
    this.setState({
      editId,
      editType
    })
  }

  disableEditing = () => {
    this.setState({
      editId: "",
      editType: ""
    })
  }

  render() {
    const {poll} = this.props
    const {editType, editId} = this.state

    return (
      <Fragment>
        {poll.votes.results.map((vote) => (
          <VoteComponent
            key={vote.uuid}
            isUpdateMode={vote.uuid === editId && editType === VoteTypeEdit.UPDATE}
            isModerateMode={vote.uuid === editId && editType === VoteTypeEdit.MODERATE}
            vote={vote}
            poll={poll}
            onEnableUpdateMode={this.enableEditing}
            onDisableUpdateMode={this.disableEditing}
            onEnableModerateMode={this.enableEditing}
            onDisableModerateMode={this.disableEditing}
          />
        ))}
      </Fragment>
    )
  }
}

export default VotesComponent
